import React, {Dispatch, useState} from "react"
import {IOrder} from "../../../../../models/order"
import dayjs from "dayjs"
import LineMenu from "../../../Lines/LineMenu"
import {useAppSelector} from "../../../../../hooks/redux"
import useWindowSize from "../../../../../hooks/useWindowSize"
import StatusLabel from "../../../../generic/dataDisplay/StatusLabel"
import ModalEditOrder from "../../../modals/ModalEditOrder"
import leftFillNum from "../../../../../utils/leftFillNum"
import {useNavigate} from "react-router-dom"
import classes from "./OrderLine.module.scss"
import numberFormat from "../../../../../utils/numberFormat"

interface IOrderLineProps {
  order: IOrder
  editSuccess: Dispatch<any>
  copySuccess: Dispatch<any>
}

function OrderLine({order, editSuccess, copySuccess}: IOrderLineProps) {

  const navigate = useNavigate()
  const windowSize = useWindowSize()
  const [modalEditShown, modalEditToggle] = useState(false)
  const [modalCopyShown, modalCopyToggle] = useState(false)
  const {paymentTypes} = useAppSelector(state => state.order)
  const brigades = useAppSelector(state => state.brigade.list)
  const orderBrigade = brigades.find(item => item.id === order.brigade_id)
  const orderPaymentType = paymentTypes.find(item => item.id === order.payment_type_id)

  const modalEdit = modalEditShown &&
    <ModalEditOrder
      close={() => modalEditToggle(false)}
      editSuccess={editSuccess}
      editID={order.id}
    />

  const modalCopy = modalCopyShown &&
    <ModalEditOrder
      close={() => modalCopyToggle(false)}
      editSuccess={copySuccess}
      editID={order.id}
      makeCopy
    />

  const menuList = [
    {
      id: 1,
      text: "Редактировать",
      onClick: () => modalEditToggle(true)
    },
    {
      id: 2,
      text: "Копировать",
      onClick: () => modalCopyToggle(true)
    }
  ]

  const arRequestDateTime = []
  const requestDate = order.request_date && dayjs(order.request_date, "YYYY-MM-DD").format("DD.MM.YYYY")

  if (requestDate)
    arRequestDateTime.push(requestDate)

  if (order.request_time)
    arRequestDateTime.push(order.request_time)

  const arAddressFromFull = []

  if (order.city_from)
    arAddressFromFull.push(order.city_from)

  if (order.address_from)
    arAddressFromFull.push(order.address_from)

  if (order.flat_from)
    arAddressFromFull.push(`кв. ${order.flat_from}`)

  const arAddressFromShort = []

  if (order.address_from)
    arAddressFromShort.push(order.address_from)

  if (order.flat_from)
    arAddressFromShort.push(`кв. ${order.flat_from}`)

  const arAddressToFull = []

  if (order.city_to)
    arAddressToFull.push(order.city_to)

  if (order.address_to)
    arAddressToFull.push(order.address_to)

  if (order.flat_to)
    arAddressToFull.push(`кв. ${order.flat_to}`)

  const arAddressToShort = []

  if (order.address_to)
    arAddressToShort.push(order.address_to)

  if (order.flat_to)
    arAddressToShort.push(`кв. ${order.flat_to}`)

  return (
    <>
      {windowSize.width >= 1920 &&
        <div className={classes.wrap}>
          <div className={[classes.field, classes.field_date].join(" ")}>
            <span onClick={() => navigate(`/order/${order.id}`)}>{arRequestDateTime.length ? arRequestDateTime.join(", ") : "—"}</span>
          </div>
          <div className={classes.field}><div>{arAddressFromFull.length ? arAddressFromFull.join(", ") : "—"}</div></div>
          <div className={classes.field}><div>{arAddressToFull.length ? arAddressToFull.join(", ") : "—"}</div></div>
          <div className={classes.field}><div>{order.client_fio}</div></div>
          <div className={classes.field}><div>{order.client_phone}</div></div>
          <div className={classes.field}><div>{orderBrigade ? orderBrigade.brigade : "—"}</div></div>
          <div className={[classes.field, classes.field_price].join(" ")}><span>{order.price ? `${numberFormat(order.price)} руб.` : "—"}</span></div>
          <div className={classes.field}><div>{orderPaymentType ? orderPaymentType.name : "—"}</div></div>
          <div className={[classes.field, classes.field_link].join(" ")}>
            <div onClick={() => navigate(`/order/${order.id}`)}>
              {leftFillNum(order.id)}
            </div>
          </div>
          <div className={classes.field}><StatusLabel id={Number(order.status_id)} type={"order"}/></div>
          <div className={classes.field}><LineMenu items={menuList}/></div>
        </div>
      }
      {windowSize.width < 1920 &&
        <div className={classes.wrap}>
          <div className={[classes.column, classes.column_order].join(" ")}>
            <div className={classes.field_order_value}>
              <div className={[classes.field_order_number].join(" ")}><span>№{leftFillNum(order.id)}</span></div>
              <div className={[classes.field_order_status].join(" ")}><StatusLabel id={Number(order.status_id)} type={"order"}/></div>
              <div className={[classes.field_order_date].join(" ")}>{arRequestDateTime.length ? arRequestDateTime.join(", ") : "-"}</div>
            </div>
          </div>
          <div className={[classes.column, classes.column_waypoint].join(" ")}>
            <div className={classes.waypoint_list}>
              <div className={[classes.waypoint_switch, classes.waypoint_switch_disabled].join(" ")}></div>
              <div className={classes.waypoint_item}>
                <div className={classes.waypoint_address}>{arAddressFromShort.length ? arAddressFromShort.join(", ") : "-"}</div>
                <div className={classes.waypoint_city}>{order.city_from || `-` }</div>
              </div>
              <div className={classes.waypoint_item}>
                <div className={classes.waypoint_address}>{arAddressToShort.length ? arAddressToShort.join(", ") : "-"}</div>
                <div className={classes.waypoint_city}>{order.city_to || `-` }</div>
              </div>
            </div>
          </div>
          <div className={[classes.column, classes.column_details].join(" ")}>
            <div className={classes.details_list}>
              <div className={[classes.details_item, classes.details_item_user].join(" ")}>
                <div className={classes.details_value}>{order.client_fio || "-"}</div>
                <div className={classes.details_label}>{order.client_phone || "-"}</div>
              </div>
              <div className={[classes.details_item, classes.details_item_brigade].join(" ")}>
                <div className={classes.details_label}>{`Бригада`}</div>
                <div className={classes.details_value}>{orderBrigade ? orderBrigade.brigade : "не выбрана"}</div>
              </div>
              <div className={[classes.details_item, classes.details_item_price].join(" ")}>
                <div className={classes.details_value}>{order.price ? `${numberFormat(order.price)} руб.` : "Цена не указана"}</div>
                {orderPaymentType && <div className={classes.details_text}>{orderPaymentType.name}</div>}
              </div>
            </div>
          </div>
          <div className={classes.column_menu}>
            <LineMenu items={menuList}/>
          </div>
          <div className={classes.clickable} onClick={() => navigate(`/order/${order.id}`)}></div>
        </div>
      }
      {modalEdit}
      {modalCopy}
    </>
  )
}

export default OrderLine